var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCardContent from '@material-ui/core/CardContent';
/**
 * Kareo wrapped component of the Material-UI CardContent. The prop API has been limited to props defined in CardContentProps.
 *
 * Material-UI CardContent: [Docs](https://v4.mui.com/components/cards/), [API](https://v4.mui.com/api/card-content/)
 *
 * @storybook: [Card](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-card--card-example)
 */
var CardContent = React.forwardRef(function (props, ref) {
    return React.createElement(MuiCardContent, __assign({}, props, { ref: ref }));
});
CardContent.defaultProps = {};
CardContent.displayName = 'KareoCardContent';
export default CardContent;
